// React
import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// View
import { ProposalsBySituationPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const ProposalsBySituation = () => {
  const [plansOptions, setPlansOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const {
    sellers,
    offices,
    getSellers,
    getOffices,
    organizations,
    categoryPlans,
    getCategoryPlans,
    getOrganizations,
  } = ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const getOptionsToDepartmentInput = useCallback(async (idOrganization) => {
    await api
      .get(`/register/unit/find-by-organization/${idOrganization}`)
      .then((options) => {
        setDepartmentOptions(createData(options));
      });
  }, []);

  const getProposalStatus = async () => {
    await api.get('/proposal/get-status').then((status) => {
      setStatusOptions(createData(status));
    });
  };

  const getPlansByCategory = useCallback(async (id) => {
    await api.get(`register/plan-by-category/${id}`).then((plans) => {
      if (plans.data) {
        setPlansOptions(plans.data);
      }
    });
  }, []);

  const resetDepartmentInput = () => {
    if (validation.values.departmentInput) {
      validation.handleChange({
        target: {
          name: 'departmentInput',
          value: null,
        },
      });
    }
  };

  const resetPlanInput = () => {
    if (validation.values.planInput) {
      validation.handleChange({
        target: {
          name: 'planInput',
          value: null,
        },
      });
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      periodType: 'sale',
      sellerInput: {
        label: '',
        value: '',
      },
      organizationInput: null,
      departmentInput: null,
      proposalSituationInput: '',
      categoryPlanInput: null,
      planInput: null,
      officeInput: [],
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string(),
      periodEnds: Yup.string(),
      periodType: Yup.string(),
      sellerInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      organizationInput: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      departmentInput: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      proposalSituationInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      categoryPlanInput: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      planInput: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      officeInput: Yup.array().nullable(),
    }),

    onSubmit: (values) => {
      let officesArray = values.officeInput.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        periodType: values.periodType || null,
        seller_id: values.sellerInput?.value || null,
        organization_id: values.organizationInput?.value || null,
        unit_id: values.departmentInput?.value || null,
        proposal_status_id: values.proposalSituationInput?.value || null,
        plan_category_id: values.categoryPlanInput?.value || null,
        plan_id: values.planInput?.value || null,
        office_id: officesArray,
      };

      toggleLoading();
      api
        .create('/reports/proposal/by-status', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(response.data, 'Propostas por Situação');
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    getSellers();
    getOffices();
    getOrganizations();
    getCategoryPlans();
    getProposalStatus();
  }, []);

  return (
    <ProposalsBySituationPage
      history={history}
      createData={createData}
      validation={validation}
      resetPlanInput={resetPlanInput}
      getPlansByCategory={getPlansByCategory}
      resetDepartmentInput={resetDepartmentInput}
      getOptionsToDepartmentInput={getOptionsToDepartmentInput}
      // data
      sellers={sellers || []}
      offices={offices || []}
      plansOptions={plansOptions || []}
      categoryPlans={categoryPlans || []}
      organizations={organizations || []}
      statusOptions={statusOptions || []}
      departmentOptions={departmentOptions || []}
    />
  );
};
